<template>
    <div class="panel panel-default">
        <div class="panel-body">
            <form class="form-horizontal" @submit.prevent="$emit('submit', data)">
                <text-form-group
                        v-model="data.title"
                        name="title"
                        label="Title"
                        :error="(errors.title || [])[0]"
                />

                <text-form-group
                        v-model="data.url"
                        name="url"
                        label="URL"
                        :error="(errors.url || [])[0]"
                />

                <text-form-group
                        v-model="data.description"
                        name="description"
                        label="Description"
                        :error="(errors.description || [])[0]"
                />

                <submit-form-group button-class="btn-black"/>
            </form>
        </div>
    </div>
</template>

<script>
    import SubmitFormGroup from '@/vendor/forms/FormGroups/Horizontal/Submit'
    import TextFormGroup from '@/vendor/forms/FormGroups/Horizontal/Text'

    export default {
        components: {SubmitFormGroup, TextFormGroup},

        props: {
            value: {
                required: true
            },

            errors: {
                required: true
            }
        },

        data() {
            return {
                data: {...this.value}
            }
        },

        watch: {
            value() {
                this.data = {...this.value}
            }
        }
    }
</script>
